/**
 * ViewModel: Tiering Settings
 * Presentation logic for tiering settings feature.
 */

import type { Dispatch, SetStateAction } from "react";
import type {
	FetchTieringSettingsParams,
	TieringSettingsItem,
	TieringSettingsPaging,
} from "../../domain/model/TieringSettingsModel";
import { FetchTieringSettingsPaginatedUseCase } from "../../domain/usecase/FetchTieringSettingsUseCase";

export interface TieringSettingsViewModelParams {
	setItems: Dispatch<SetStateAction<TieringSettingsItem[]>>;
	setIsLoading: Dispatch<SetStateAction<boolean>>;
	setPaging: Dispatch<SetStateAction<TieringSettingsPaging | null>>;
	setError: Dispatch<SetStateAction<string | null>>;
}

export const TieringSettingsViewModel = ({
	setItems,
	setIsLoading,
	setPaging,
	setError,
}: TieringSettingsViewModelParams) => {
	const loadTieringSettings = async (
		params: FetchTieringSettingsParams = {},
	) => {
		try {
			setIsLoading(true);
			setError(null);

			const result = await FetchTieringSettingsPaginatedUseCase(params);

			setItems(result.items.slice());
			setPaging(result.paging);
		} catch (error) {
			console.error("Failed to load tiering settings:", error);
			setItems([]);
			setPaging(null);
			setError("Failed to load tiering settings. Please try again.");
		} finally {
			setIsLoading(false);
		}
	};

	return {
		loadTieringSettings,
	};
};
